module.exports = __webpack_public_path__ + "fonts/payback_bold-webfont.fa3396f6.woff";